module.exports = __webpack_public_path__ + "static/media/angle-up.fffe3920.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/angle-up.svg
// module id = 964
// module chunks = 3